import React, { FC } from "react";

import type { BoxProps } from "@chakra-ui/react";
import DOMPurify from "dompurify";

import { Box } from "../Container";

export interface ISafeHtmlRendererProps extends BoxProps {
  html: string;
  allowedTags?: string[];
  allowedAttributes?: string[];
}

const SafeHtmlRenderer: FC<ISafeHtmlRendererProps> = ({
  html,
  allowedTags = [
    "b",
    "i",
    "em",
    "strong",
    "a",
    "br",
    "span",
    "div",
    "p",
    "ul",
    "ol",
    "li",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "blockquote",
    "code",
    "pre",
    "mark",
    "small",
    "sub",
    "sup",
    "del",
    "ins",
    "kbd",
    "samp",
    "var",
    "time",
    "abbr",
  ],
  allowedAttributes = [
    "href",
    "target",
    "rel",
    "class",
    "style",
    "id",
    "title",
    "alt",
    "src",
    "width",
    "height",
    "data-*",
    "aria-*",
  ],
  ...boxProps
}) => {
  const sanitizedHtml = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: allowedTags,
    ALLOWED_ATTR: allowedAttributes,
    ALLOW_DATA_ATTR: true, // Allow data-* attributes
    ALLOW_UNKNOWN_PROTOCOLS: false, // Prevent javascript: and other dangerous protocols
    FORBID_TAGS: [
      "script",
      "object",
      "embed",
      "form",
      "input",
      "textarea",
      "select",
      "button",
    ],
    FORBID_ATTR: [
      "onerror",
      "onload",
      "onclick",
      "onmouseover",
      "onfocus",
      "onblur",
    ],
    KEEP_CONTENT: true, // Keep content even if parent tag is removed
  });

  return (
    <Box {...boxProps} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
  );
};

export default SafeHtmlRenderer;
